/* eslint-disable react-hooks/exhaustive-deps */
/**
 *
 * SelectInstituteWithRole - Updated with new UI design
 *
 */
import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { Crown, Settings, Calculator, /* Monitor,  */Bell, ChevronDown, X, Book } from 'lucide-react';
// import { Checkbox } from 'core/components/Checkbox';
// import { Button } from 'core/components/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  useAuth,
} from 'core/context/AuthContext/AuthContextProvider';
import History from 'core/utils/history';
import { StaffRoleAuth } from 'features/Authentication/slice/types';
import { useAuthenticationSlice } from 'features/Authentication/slice';
import httpclient from 'libs/Axios';
import { AcademicYear } from 'core/utils/types/modules/org';
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader/Loadable';
import Modal from 'react-modal';
import { resetLocalStorage } from 'features/Authentication/slice/saga';
import axios from 'axios';
import { RootState } from 'controller/types';
import { error } from 'core/components/Notify';
import { applyAccessDataToAuth, getFirstAccessiblePath, selectStaffRoleAccessForAuth } from 'core/utils/accessControl';
import { isCounselorStaffRole } from 'core/utils/role/index';
import { API_HOST } from 'core/utils/constants/ApiConstants';
// import { goBack } from 'core/utils/constants';

const isAdmissionsAssuredEnabled = true;
const getSelectableRoles = (roles: StaffRoleAuth[] = []) =>
  isAdmissionsAssuredEnabled
    ? roles
    : roles.filter(role => !isCounselorStaffRole(role?.STAFF_ROLE_NAME));

interface Props { }

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '1.5em',
    boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    border: 'none',
    padding: '2rem',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    zIndex: '999',
  },
};

// Role icon mapping
const getRoleIcon = (roleName: string) => {
  const roleIconMap: { [key: string]: any } = {
    'SUPERADMIN': Crown,
    'SUPER ADMIN': Crown,
    'ADMIN': Settings,
    'ADMINISTRATOR': Settings,
    'ACCOUNTANT': Calculator,
    'FACULTY': Book,
    'TEACHER': Book,
    'FRONT DESK': Bell,
    'FRONTDESK': Bell,
    'RECEPTIONIST': Bell,
    'DEFAULT': Settings
  };

  const normalizedRole = roleName.toUpperCase().replace(/[^A-Z]/g, '');
  return roleIconMap[normalizedRole] || roleIconMap[roleName.toUpperCase()] || roleIconMap['DEFAULT'];
};

// Role description mapping
const getRoleDescription = (roleName: string) => {
  const descriptionMap: { [key: string]: string } = {
    'SUPERADMIN': 'Full system access',
    'SUPER ADMIN': 'Full system access',
    'ADMIN': 'Administrative privileges',
    'ADMINISTRATOR': 'Administrative privileges',
    'ACCOUNTANT': 'Financial management',
    'FACULTY': 'Teaching and academic',
    'TEACHER': 'Teaching and academic',
    'FRONT DESK': 'Reception and support',
    'FRONTDESK': 'Reception and support',
    'RECEPTIONIST': 'Reception and support',
    'COUNSELOR': 'Complete admission management',
  };

  return descriptionMap[roleName.toUpperCase()] || 'Role-based access';
};

export const SelectInstituteWithRole = memo((props: Props) => {

  let cancelTokenSource: any;
  const { t } = useTranslation();
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  const state: any = useSelector((state: RootState) => state.authentication);

  const { actions } = useAuthenticationSlice();
  const authData: any = useAuth();
  const dispatch = useDispatch();

  const [option, setOption] = useState<StaffRoleAuth>({
    STAFF_ID: 0,
    STAFF_ROLE_ID: 0,
    STAFF_ROLE_NAME: '',
  });
  const [isDefaultRole/* , setDefaultRole */] = useState<boolean>(false);
  // const [module, setModule] = useState<any>();
  const [institute, setInstitute] = useState<any>();
  const [loginData, setLoginData] = useState<any>();
  const [selectedProfile, setSelectedProfile] = useState<any>();
  const [loader, setloader] = useState<boolean>(false);
  const [isCancelling, setIsCancelling] = useState<boolean>(false);
  const [isInstituteDropdownOpen, setIsInstituteDropdownOpen] = useState(false);
  const [showModal, setshowModal] = React.useState<{
    display: boolean;
    ID: number | undefined;
  }>({ display: false, ID: undefined });

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsInstituteDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const itemsSavedInLocal = JSON.parse(EncryptedStorage.getItem('branch_roles') as any);

  useEffect(() => {
    if (window.location.pathname.includes('user-roles') && itemsSavedInLocal && itemsSavedInLocal?.length) {
      dispatch(actions.updateAuthData({ ...authData, BRANCH_ROLE_LIST: [...itemsSavedInLocal] }));
    }
  }, []);

  const handleInstitute = async (selectedInstitute) => {
    const isPreAuthInstituteFlow = !!authData?.PRE_AUTH_TOKEN && !!authData?.INSTITUTES?.length;

    if (isPreAuthInstituteFlow) {
      try {
        setloader(true);
        setInstitute(selectedInstitute);
        setLoginData(null);
        setSelectedProfile(null);
        setOption({
          STAFF_ID: 0,
          STAFF_ROLE_ID: 0,
          STAFF_ROLE_NAME: '',
        });

        const response = await httpclient({ ipAddress: authData?.IP_ADDRESS }).post('/auth/login/web/select-institute', {
          PRE_AUTH_TOKEN: authData?.PRE_AUTH_TOKEN,
          INSTITUTE_ID: selectedInstitute?.INSTITUTE_ID,
          BRANCH_ID: selectedInstitute?.BRANCH_ID,
          SOURCE: authData?.SOURCE || 'STAFF',
          DEVICE_TYPE: authData?.DEVICE_TYPE || 'WEB',
          FORCE_LOGIN_ID: authData?.FORCE_LOGIN_ID || null,
          LOCATION: authData?.LOCATION || '',
        });

        const selectedLoginData = {
          ...response?.data?.data,
          CHANGE_PW: !!authData?.CHANGE_PW || !!response?.data?.data?.CHANGE_PW,
          IP_ADDRESS: authData?.IP_ADDRESS,
          SELECTED_WEB_INSTITUTE: selectedInstitute,
        };

        if (selectedLoginData?.CHANGE_PW) {
          EncryptedStorage.removeItem('_DATA_');
          dispatch(actions.clearState());
          History.navigate(`/reset-password?__user_id=${selectedLoginData?.USER_ID}&__token=${encodeURIComponent(selectedLoginData?.ACCESS_TOKEN)}`);
          return;
        }

        const firstProfile = selectedLoginData?.USER_INFO?.length === 1 ? selectedLoginData.USER_INFO[0] : null;

        setLoginData(selectedLoginData);
        setSelectedProfile(firstProfile);
        const firstProfileRoles = getSelectableRoles(
          firstProfile?.STAFF_INFO || []
        );
        if (firstProfileRoles.length === 1) {
          setOption(firstProfileRoles[0]);
        }
      } catch (err: any) {
        error(err?.response?.data?.message || err?.message || 'Unable to select institute', true);
      } finally {
        setloader(false);
        setIsInstituteDropdownOpen(false);
      }
      return;
    }

    const { USER_INFO, ...reset }: any = authData;

    EncryptedStorage.setItem('USER_INFO', JSON.stringify(USER_INFO));

    let obj = reset?.CHANGE_ROLE_IF_ALREADY_LOGIN ?
      { ...reset, ...selectedInstitute } :
      { ...selectedInstitute, ...reset };
    obj.ROLE = selectedInstitute?.USER_ROLE_NAME;

    setInstitute(() => null);
    // setModule(null);
    setOption(() => ({
      STAFF_ID: 0,
      STAFF_ROLE_ID: 0,
      STAFF_ROLE_NAME: '',
    }));

    const selectedInstituteRoles = getSelectableRoles(
      selectedInstitute?.STAFF_INFO || []
    );
    setTimeout(() => {
      if (selectedInstituteRoles.length === 1) {
        setOption(() => selectedInstituteRoles[0]);
      }
      setInstitute(obj);
    }, 50);

    setIsInstituteDropdownOpen(() => false);
  };

  const handleRoleSelect = (selectedRole: StaffRoleAuth) => {
    setOption(selectedRole);
  };

  const handleProfileSelect = (profile: any) => {
    setSelectedProfile(profile);
    setOption({
      STAFF_ID: 0,
      STAFF_ROLE_ID: 0,
      STAFF_ROLE_NAME: '',
    });

    const profileRoles = getSelectableRoles(profile?.STAFF_INFO || []);
    if (profileRoles.length === 1) {
      setOption(profileRoles[0]);
    }
  };

  const handleDashboardEnter = async () => {
    try {
      setloader(true);
      const selectedLoginData = loginData || authData;
      const selectedInstituteInfo = selectedProfile || institute;
      const {
        USER_INFO: _userInfo,
        INSTITUTES: _institutes,
        PRE_AUTH_TOKEN: _preAuthToken,
        ...loginDataWithoutSelectionLists
      } = selectedLoginData || {};
      let preparedInstitute = loginData
        ? {
          ...loginDataWithoutSelectionLists,
          ...selectedInstituteInfo,
          IS_LOGGED_IN: true,
          IS_INSTITUTE_SELECTION_PENDING: false,
          ROLE: selectedInstituteInfo?.USER_ROLE_NAME,
          STAFF_ROLE: option,
        }
        : {
          ...institute,
          STAFF_ROLE: option,
          IS_INSTITUTE_SELECTION_PENDING: false,
        };

      // setting up the db and other stuff start
      EncryptedStorage.setItem('_UFT_', `Bearer ${preparedInstitute?.ACCESS_TOKEN}`);
      EncryptedStorage.setItem('_DATA_', JSON.stringify(preparedInstitute));
      EncryptedStorage.setItem('_DATABASE_', preparedInstitute?.DATABASE);
      const accessClient = httpclient();
      accessClient.clearHeaderCache?.();
      accessClient.refreshCache?.();
      // setting up the db and other stuff end

      // Select staff role on backend and replace the old JWT before any follow-up API call.
      const selectedRoleResponse = await selectStaffRoleAccessForAuth(preparedInstitute, option);
      const selectedRoleAccessData = selectedRoleResponse?.data?.data || {};
      preparedInstitute = {
        ...preparedInstitute,
        ACCESS_TOKEN: selectedRoleAccessData?.ACCESS_TOKEN || preparedInstitute?.ACCESS_TOKEN,
        STAFF_ROLE: selectedRoleAccessData?.STAFF_ROLE || option,
      };
      EncryptedStorage.setItem('_UFT_', `Bearer ${preparedInstitute?.ACCESS_TOKEN}`);
      EncryptedStorage.setItem('_DATA_', JSON.stringify(preparedInstitute));
      accessClient.clearHeaderCache?.();
      accessClient.refreshCache?.();

      if (("BRANCH_SETUP" in preparedInstitute) && preparedInstitute?.BRANCH_SETUP !== 'COMPLETED') {
        // MASTER_DATA list start
        const masterData = await httpclient().get(`/master/prerequisites`);
        preparedInstitute.MASTER_DATA = masterData?.data?.data || {};
        // MASTER_DATA list end
      }

      // COLUMNS list start
      const columnsResponse = await httpclient().get(`/master/tableColumnDisplay/list?institute_id=${preparedInstitute?.INSTITUTE_ID}&branch_id=${preparedInstitute?.BRANCH_ID}`);
      preparedInstitute.COLUMNS = columnsResponse?.data?.data?.TableColumnDisplayList || [];
      // COLUMNS list end

      // branch role list start
      // Data-manager calls 403 while the branch has no active plan. Keep each
      // one from aborting the rest — MASTER_DATA above and the _DATA_ write
      // below would otherwise be lost, and nothing refetches them later.
      try {
        const branchRoleresponse = await httpclient().get(`/data/branchRole/list/${preparedInstitute?.BRANCH_ID}`);
        const branchRoledata = branchRoleresponse.data?.data?.BranchRoleList as any[];
        preparedInstitute.BRANCH_ROLE_LIST = branchRoledata as any[];
      } catch (branchRoleError) {
        console.error('Unable to load branch roles:', branchRoleError);
      }
      // branch role list end

      // academic year start
      try {
        const academicYearresponse = await httpclient().get(`/data/academicYear/list/${preparedInstitute?.BRANCH_ID}`);
        const academicYeardata = academicYearresponse?.data?.data?.AcademicYearList as AcademicYear[];
        const dataAt0 = academicYeardata?.find(item => item?.ACADEMIC_YEAR_ID === preparedInstitute?.CURRENT_ACADEMIC_YEAR_ID);
        preparedInstitute.ACADEMIC_YEARS = academicYeardata as AcademicYear[];
        preparedInstitute.SELECTED_ACADEMIC_YEAR = dataAt0 as AcademicYear;
        EncryptedStorage.setItem('_SELECTED_ACADEMIC_YEAR_', JSON.stringify(dataAt0 as AcademicYear));
      } catch (academicYearError) {
        console.error('Unable to load academic years:', academicYearError);
      }
      // academic year end

      // access control start
      const registryResponse = await accessClient.get('/auth/access/registry');
      preparedInstitute = applyAccessDataToAuth(
        preparedInstitute,
        registryResponse?.data?.data,
        selectedRoleAccessData,
      );
      const nextPath = isAdmissionsAssuredEnabled && isCounselorStaffRole(preparedInstitute?.STAFF_ROLE?.STAFF_ROLE_NAME)
        ? '/admissions'
        : getFirstAccessiblePath(preparedInstitute?.Modules);
      EncryptedStorage.setItem('_DATA_', JSON.stringify(preparedInstitute));
      accessClient.clearHeaderCache?.();
      accessClient.refreshCache?.();
      // access control end

      // branch list start only for SUPERADMIN
      if (option?.STAFF_ROLE_NAME === "SUPERADMIN") {
        try {
          const response = await httpclient().get(`/data/branch/list/${preparedInstitute?.INSTITUTE_ID}`);
          const data = response?.data?.data?.BranchList as any[];
          preparedInstitute.BRANCH_LIST = data as any[];
        } catch (branchListError) {
          console.error('Unable to load branch list:', branchListError);
        }
      }
      // branch list end only for SUPERADMIN

      dispatch(actions.updateAuthDataOnInstituteSelection(preparedInstitute));
      if (isDefaultRole) {
        EncryptedStorage.setItem('_DEFAULT_ROLE_', JSON.stringify(option));
      }
      setloader(false);
      if (isAdmissionsAssuredEnabled && isCounselorStaffRole(preparedInstitute?.STAFF_ROLE?.STAFF_ROLE_NAME)) {
        History.navigate('/admissions');
      } else if (preparedInstitute?.BRANCH_SETUP !== 'COMPLETED') {
        History.navigate('/initial-setup');
      } else {
        History.navigate(nextPath);
      }

    } catch (err: any) {
      setloader(false);
      error(err?.response?.data?.message || err?.message || 'Unable to select staff role', true);
    }
  };

  const handleCancel = async (e: React.MouseEvent) => {
    e.preventDefault();
    const sessionData = loginData || authData;
    const selectedInstituteInfo = selectedProfile || loginData?.USER_INFO?.[0] || institute || authData?.USER_INFO?.[0];
    const userLoginId = sessionData?.USER_LOGIN_ID;

    if (typeof cancelTokenSource != typeof undefined) {
      cancelTokenSource.cancel();
    }
    cancelTokenSource = axios.CancelToken.source();

    try {
      setIsCancelling(true);

      if (userLoginId) {
        await axios.post(
          `${API_HOST}auth/logout`,
          { USER_LOGIN_ID: userLoginId },
          {
            cancelToken: cancelTokenSource.token,
            headers: {
              Authorization: `Bearer ${sessionData?.ACCESS_TOKEN}`,
              'INSTITUTE-ID': selectedInstituteInfo?.INSTITUTE_ID || sessionData?.SELECTED_WEB_INSTITUTE?.INSTITUTE_ID,
              'BRANCH-ID': selectedInstituteInfo?.BRANCH_ID || sessionData?.SELECTED_WEB_INSTITUTE?.BRANCH_ID,
              'ACADEMIC-YEAR-ID': selectedInstituteInfo?.CURRENT_ACADEMIC_YEAR_ID || sessionData?.CURRENT_ACADEMIC_YEAR_ID,
              'USER-ROLE': selectedInstituteInfo?.USER_ROLE_NAME || sessionData?.USER_ROLE_NAME || sessionData?.SOURCE || 'STAFF',
              'USER-NAME': sessionData?.USER_NAME,
              'USER-ID': sessionData?.USER_ID,
              database: selectedInstituteInfo?.DATABASE || sessionData?.DATABASE,
              SOURCE: sessionData?.SOURCE || 'STAFF',
              'Ip-Address': sessionData?.IP_ADDRESS || '',
            },
          },
        );
      }
    } catch (logoutError) {
      // A failed backend logout must not leave the browser authenticated.
      console.error('Unable to logout the selected institute session', logoutError);
    } finally {
      resetLocalStorage();
      dispatch(actions.clearState());
      window.location.href = '/login';
    }
  };

  const isPreAuthInstituteFlow = !!authData?.PRE_AUTH_TOKEN && !!authData?.INSTITUTES?.length;
  const availableInstitutes = isPreAuthInstituteFlow ? (authData?.INSTITUTES || []) : (authData?.USER_INFO || []);
  const availableProfiles = loginData?.USER_INFO || [];
  const availableRoles = getSelectableRoles(
    ((selectedProfile || institute)?.STAFF_INFO || []) as StaffRoleAuth[]
  );
  const hasMultipleRoles = availableRoles.length > 1;

  return (
    <Div className="font-poppins min-h-screen bg-[url('/src/assets/images/imageBG.webp')] bg-cover bg-center flex items-center justify-center p-4">
      {t('')}

      {/* Modal */}
      <Modal
        isOpen={showModal?.display}
        contentLabel="Contact Admin Modal"
        style={customStyles}
      >
        <div className="flex justify-end mb-4">
          <X
            className="w-6 h-6 cursor-pointer text-gray-600 hover:text-gray-800"
            onClick={() => {
              setshowModal({ display: false, ID: undefined });
              window.history.back();
            }}
          />
        </div>
        <div className="text-center">
          <h1 className='text-[3.5vh] font-bold text-gray-800 mb-4'>Please Contact Admin</h1>
        </div>
      </Modal>

      <div className="w-full text-center">
        {/* Institute Selection */}
        {!!availableInstitutes?.length && (
          <div className="flex justify-center w-full mb-12">
            <div className='w-full max-w-3xl'>
              <h1 className="text-[white] text-[3.5vh] font-semibold mb-8">Select Institute</h1>
              <div ref={dropdownRef} className="relative max-w-5xl mx-auto">
                <button
                  onClick={() => setIsInstituteDropdownOpen(!isInstituteDropdownOpen)}
                  className="w-full bg-[white]/10 backdrop-blur-sm border border-[white]/20 rounded-xl px-6 py-4 text-[white] text-left flex items-center justify-between hover:bg-[white]/15 transition-all duration-200"
                >
                  <span className="text-[2vh]">
                    {institute ? `${institute.INSTITUTE_NAME}${institute.BRANCH_NAME ? ` - ${institute.BRANCH_NAME}` : ''}` : 'Select Institute...'}
                  </span>
                  <ChevronDown className={`w-5 h-5 transition-transform duration-200 ${isInstituteDropdownOpen ? 'rotate-180' : ''}`} />
                </button>

                {isInstituteDropdownOpen && (
                  <div className="absolute top-full mt-2 w-full bg-[white]/10 backdrop-blur-sm border border-[white]/20 rounded-xl overflow-hidden z-10 max-h-60 overflow-y-auto">
                    {availableInstitutes.map((inst: any, index: number) => (
                      <div
                        key={index}
                        onClick={() => handleInstitute(inst)}
                        className="p-4 text-[white] hover:bg-[white]/10 cursor-pointer border-b border-[white]/10 last:border-b-0"
                      >
                        {`${inst.INSTITUTE_NAME}${inst.BRANCH_NAME ? ` - ${inst.BRANCH_NAME}` : ''}`}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {availableProfiles?.length > 1 && (
          <div className="mb-12 animate-fadeInUp">
            <h2 className="text-[white] text-[3.5vh] font-semibold mb-8">Select User</h2>
            <div className="flex flex-wrap justify-center gap-4 max-w-5xl mx-auto">
              {availableProfiles.map((profile: any, index: number) => {
                const isSelected = selectedProfile === profile;
                return (
                  <button
                    key={`${profile?.USER_ID}-${profile?.NAME}-${index}`}
                    onClick={() => handleProfileSelect(profile)}
                    className={`px-6 py-4 rounded-xl border transition-all ${isSelected
                      ? 'bg-[white] text-gray-800 border-[white]'
                      : 'bg-[white]/10 text-[white] border-[white]/20 hover:bg-[white]/15'
                      }`}
                  >
                    <div className="font-semibold">{profile?.NAME || profile?.USER_NAME}</div>
                    <div className="text-sm opacity-80">{profile?.INSTITUTE_NAME}</div>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* Role Selection */}
        {(selectedProfile || institute) && (
          <div className="mb-12 animate-fadeInUp">
            <h2 className="text-[white] text-[3.5vh] font-semibold mb-12">
              {hasMultipleRoles ? 'Select Your Role' : 'Your Role'}
            </h2>

            {hasMultipleRoles ? (
              <div className="flex flex-wrap justify-center gap-12 max-w-6xl mx-auto">
                {availableRoles.map((role: StaffRoleAuth) => {
                  const IconComponent = getRoleIcon(role.STAFF_ROLE_NAME);
                  const isSelected = option.STAFF_ROLE_ID === role.STAFF_ROLE_ID;

                  return (
                    <div key={role.STAFF_ROLE_ID} className="flex flex-col items-center space-y-3">
                      <button
                        onClick={() => handleRoleSelect(role)}
                        className={`group relative w-24 h-24 rounded-full transition-all duration-300 transform hover:scale-105 flex items-center justify-center ${isSelected
                          ? 'bg-[white] shadow-2xl shadow-[white]/20'
                          : 'bg-[white]/10 backdrop-blur-sm border border-[white]/20 hover:bg-[white]/15'
                          }`}
                      >
                        <IconComponent className={`w-8 h-8 transition-colors duration-300 ${isSelected
                          ? 'text-purple-600'
                          : 'text-[white] group-hover:text-[white]'
                          }`} />

                        {/* Selection indicator */}
                        {/* {isSelected && (
                  <div className="absolute -top-1 -right-1">
                    <div className="w-5 h-5 bg-purple-600 rounded-full flex items-center justify-center">
                      <div className="w-1.5 h-1.5 bg-[white] rounded-full"></div>
                    </div>
                  </div>
                )} */}
                      </button>

                      <div className="text-center">
                        <h3 className={`font-medium text-base transition-colors duration-300 whitespace-nowrap ${isSelected ? 'text-[white]' : 'text-[white]'
                          }`}>
                          {role.STAFF_ROLE_NAME}
                        </h3>
                        <p className="text-[white]/70 text-sm mt-1">
                          {getRoleDescription(role.STAFF_ROLE_NAME)}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              // Single role display
              availableRoles?.length === 1 && (
                <div className="flex justify-center">
                  <div className="flex flex-col items-center space-y-3">
                    <div className="w-24 h-24 rounded-full bg-[white] shadow-2xl shadow-[white]/20 flex items-center justify-center">
                      {React.createElement(getRoleIcon(availableRoles?.[0]?.STAFF_ROLE_NAME), {
                        className: 'w-8 h-8 text-purple-600'
                      })}
                    </div>
                    <div className="text-center">
                      <h3 className="font-medium text-base text-[white] whitespace-nowrap">
                        {availableRoles?.[0]?.STAFF_ROLE_NAME}
                      </h3>
                      <p className="text-[white]/70 text-sm mt-1">
                        {getRoleDescription(availableRoles?.[0]?.STAFF_ROLE_NAME)}
                      </p>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        )}

        {/* Remember Me Checkbox */}
        {/* {institute && (
          <div className="mb-8 flex justify-center animate-slideInFromTop">
            <div className="flex items-center space-x-3 bg-[white]/10 backdrop-blur-sm border border-[white]/20 rounded-lg px-6 py-3">
              <Checkbox
                bordercolor="border-[white]"
                width="w-5 h-5"
                checked={isDefaultRole}
                setChecked={setDefaultRole}
              />
              <span className="text-[white] text-[2vh]">Remember Me</span>
            </div>
          </div>
        )} */}

        {/* Action Buttons */}
        {institute && (
          <div className="flex justify-center space-x-6 animate-slideInFromTop">
            {loader ? (
              <div className="bg-neutral-light flex items-center justify-center p-4 rounded-full">
                <SetupLoader width="w-12" height="h-12" />
              </div>
            ) : (
              <>
                {!state.isLoggingOut && !isCancelling ? (
                  <button
                    onClick={handleCancel}
                    className="bg-[white]/10 backdrop-blur-sm border border-[white]/20 text-[white] font-semibold px-8 py-4 rounded-xl hover:bg-[white]/15 transition-all duration-200 min-w-[120px]"
                  >
                    Cancel
                  </button>
                ) : (
                  <div className="flex items-center justify-center min-w-[120px] py-4">
                    <SetupLoader width="w-8" height="h-8" />
                  </div>
                )}

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleDashboardEnter();
                  }}
                  disabled={!option?.STAFF_ID || !institute}
                  className={`font-semibold px-12 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 min-w-[160px] ${(option?.STAFF_ID && institute)
                    ? 'bg-[white] text-gray-800 hover:bg-gray-50'
                    : 'bg-[white]/30 text-[white]/50 cursor-not-allowed'
                    }`}
                >
                  Continue
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </Div>
  );
});

const Div = styled.div`
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fadeInUp {
    animation: fadeInUp 0.6s ease-out;
  }

  @keyframes slideInFromTop {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-slideInFromTop {
    animation: slideInFromTop 0.4s ease-out;
  }
`;
